import type { Me } from '../lib/types';

export const IMPERSONATION_REASON_MIN = 10;
export const IMPERSONATION_REASON_MAX = 500;
export const IMPERSONATION_MINUTES = [15, 30, 60] as const;

/** Görüntüleme bitince giriş sayfasına eklenen işaret: /auth/login?ended=impersonation */
export const IMPERSONATION_ENDED_PARAM = 'ended';
export const IMPERSONATION_ENDED_VALUE = 'impersonation';
export const IMPERSONATION_ENDED_PATH = `/auth/login?${IMPERSONATION_ENDED_PARAM}=${IMPERSONATION_ENDED_VALUE}`;

export function impersonationEnded(params: URLSearchParams): boolean {
  return params.get(IMPERSONATION_ENDED_PARAM) === IMPERSONATION_ENDED_VALUE;
}

export function canImpersonateUser(input: { self: boolean; status: string; impersonating: boolean; permitted: boolean }): boolean {
  return input.permitted && !input.self && !input.impersonating && input.status === 'active';
}

export function impersonationReasonProblem(reason: string): string | null {
  const n = reason.trim().length;
  if (n < IMPERSONATION_REASON_MIN) return `Neden en az ${IMPERSONATION_REASON_MIN} karakter olmalı`;
  if (n > IMPERSONATION_REASON_MAX) return `Neden en fazla ${IMPERSONATION_REASON_MAX} karakter olabilir`;
  return null;
}

/** Yalnızca aynı origin'deki göreli yolları kabul eder. */
export function safeHandoffPath(path: string): string | null {
  return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\') ? path : null;
}

const ERRORS: Record<string, string> = {
  CANNOT_IMPERSONATE_SELF: 'Kendi hesabınızı görüntüleyemezsiniz.',
  USER_NOT_FOUND: 'Kullanıcı bulunamadı.',
  USER_INACTIVE: 'Yalnızca aktif kullanıcılar görüntülenebilir.',
  ALREADY_IMPERSONATING: 'Zaten bir kullanıcıyı görüntülüyorsunuz.',
  IMPERSONATION_NOT_ALLOWED: 'Sizden daha geniş yetkili bir kullanıcıyı görüntüleyemezsiniz.',
};

/** Bilinen hata kodları için Türkçe mesaj; IMPERSONATION_NOT_ALLOWED'da eksik yetkiler eklenir. */
export function impersonationErrorText(code: string | undefined, details: unknown, fallback: string): string {
  const base = (code && ERRORS[code]) || fallback;
  if (code !== 'IMPERSONATION_NOT_ALLOWED') return base;
  const perms = details && typeof details === 'object' && 'permissions' in details ? (details as { permissions: unknown }).permissions : null;
  const list = Array.isArray(perms) ? perms.filter((p): p is string => typeof p === 'string') : [];
  return list.length ? `${base} Eksik yetkiler: ${list.join(', ')}` : base;
}

export function impersonationBannerTitle(me: Pick<Me, 'firstName' | 'lastName' | 'impersonation'>): string {
  const imp = me.impersonation;
  if (!imp) return '';
  const target = [me.firstName, me.lastName].filter(Boolean).join(' ') || 'Kullanıcı';
  const suffix = imp.readOnly ? ' (salt okunur)' : '';
  if (imp.actor.type === 'user') return `${target} olarak görüntülüyorsunuz${suffix} - başlatan: ${imp.actor.name ?? 'yetkili'}`;
  if (imp.mode === 'admin') return `Platform destek yöneticisi olarak görüntülüyorsunuz${suffix}`;
  return `${target} olarak görüntülüyorsunuz${suffix}`;
}
